export default abstract class ChatPacket {

}
